/**
 * Open Dental Familiar wording. OWNER: the Open Dental Familiar agent.
 *
 * Every entry is the exact label Open Dental v24 shows for the same thing
 * (theme spec 4.11 and NOTES-opendental.md section 3, verified as text in
 * the manual or visible in its screenshots). Only words that differ from
 * Velora are listed. Labels with no term key yet (Pat Appts, Make Appt,
 * Daily Prod, =Est Bal ...) are requested in
 * docs/themes/requests-opendental.md and used literally in this mode's
 * own components meanwhile.
 */
import type { TermMap } from '../terms.js';

export const terms: TermMap = {
  /* Modules: the left module bar labels, in OD's order. */
  schedule: 'Appts',
  familyFile: 'Family',
  patientFile: 'Family',
  ledger: 'Account',
  txPlan: 'Tx Plan',
  chart: 'Chart',
  perio: 'Perio Chart',
  clinicalNotes: 'Progress Notes',
  progressNotes: 'Progress Notes',
  reports: 'Reports',
  contactLog: 'Commlog',

  /* People and records. */
  selectPatient: 'Select Patient',
  headOfHouse: 'Guarantor',
  household: 'Family',
  chartNumber: 'Chart Number',
  patientId: 'PatNum',
  office: 'Clinic',
  newPatient: 'NP',
  alerts: 'Popups',

  /* Scheduling. */
  unscheduledList: 'Unsched List',
  asapList: 'ASAP List',
  breakAppointment: 'Break',
  setComplete: 'Set Complete',
  routeSlip: 'Routing Slip',
  statusSeated: 'In Room',
  statusCheckout: 'ChkOut',

  /* Money (Account module). */
  insurancePayment: 'InsPay',
  writeoff: 'Writeoff',
  statement: 'Statement',
  paymentPlan: 'Payment Plan',
  estInsurance: '-InsEst',
  estPatient: 'Pat Est Bal',
  daySheet: 'Daily Payments',

  /* Clinical (Chart module, Enter Treatment). */
  procedureButtons: 'Quick Buttons',
  procedureCodes: 'Procedure Codes',
  txStatusPlanned: 'TreatPlan',
  txStatusComplete: 'Complete',
  txStatusExisting: 'ExstCurProv',
  txStatusExistingOther: 'ExstOther',

  /* Menu bar: "Log Off File Setup Lists Reports Tools eServices Alerts Help". */
  menuVelora: '&Velora',
};
